module.exports = __webpack_public_path__ + "static/media/pdf-icon--white.b807ccc8.svg";